<iframe
  [attr.data-tally-src]="tally"
  loading="lazy"
  width="100%"
  height="409"
  frameborder="0"
  marginheight="0"
  marginwidth="0"
></iframe>
